import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { AppErrorScreen } from '@/app/errors/AppErrorScreen';
import { reportClientError } from '@/shared/lib/error/reportClientError';
/**
 * 数据路由的根级错误元素：兜住路由渲染与 loader 抛出的异常，
 * 渲染与 AppErrorBoundary 一致的降级界面，并上报到客户端监控。
 * 迁移到数据路由后路由异常由 React Router 的错误边界先捕获，
 * 因此需要在 errorElement 上补回原有界面与上报能力。
 */
export function AppRouteErrorFallback() {
    /** 路由抛出的原始错误，可能是 Error，也可能是 Response（redirect / 4xx 响应）。 */
    const error = useRouteError();
    useEffect(() => {
        reportClientError('route', error instanceof Error ? error : new Error(String(error)));
    }, [error]);
    return _jsx(AppErrorScreen, {});
}
